import round_to_two_decimals from "./round_to_two_decimals"

export default (price_excluding_shipping, shipping_price) => {
  if (shipping_price) price_excluding_shipping += Number(shipping_price)

  return round_to_two_decimals(price_excluding_shipping)
}